<template>
  <v-container class="pt-0">
    <v-toolbar flat />

    <v-row>
      <v-col cols="12">
        <v-row
          align="center"
          justify="center"
        >
          <div class="d-block body-1">
            Setup an account to begin receiving payments from your customers
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mb-10">
      <v-col cols="12">
        <v-row
          align="center"
          justify="center"
        >
          <individual-account-update-dialog
            :account="{}"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                rounded
                outlined
                color="primary"
                v-on="on"
              >
                <v-icon left>
                  person
                </v-icon>
                Individual Account
              </v-btn>
            </template>
          </individual-account-update-dialog>
          <span class="ma-5">or</span>
          <company-account-update-dialog
            :account="{}"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                rounded
                outlined
                color="primary"
                v-on="on"
              >
                <v-icon left>
                  business
                </v-icon>
                Company Account
              </v-btn>
            </template>
          </company-account-update-dialog>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import IndividualAccountUpdateDialog from "./IndividualAccountUpdateDialog"
import CompanyAccountUpdateDialog from "./CompanyAccountUpdateDialog"

export default {
  components: {
    CompanyAccountUpdateDialog,
    IndividualAccountUpdateDialog
  }
}
</script>
